import { modalDeleteState } from '../state/page'
import {
  recipientState,
  selectedResultsState,
  tableStateResult,
  tableStateSerach,
} from '../state/result'

import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'
import {
  deleteRecipientEventsBouncesAction,
  getRecipientAction,
  getRecipientEventsBouncesAction,
} from '../actions/actions'

import { pageState } from 'State/page'

export const getRecipientCallback =
  ({ set, snapshot, reset }) =>
  async (idRecipient) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      status: 'initial',
    }))

    const { pageSize, pageNumber, orderBy, orderDescending } =
      await snapshot.getPromise(tableStateSerach)

    try {
      const resp = await getRecipientAction(idRecipient)

      const bounces = await getRecipientEventsBouncesAction(
        idRecipient,
        pageSize,
        pageNumber,
        orderBy,
        orderDescending,
      )

      set(recipientState, (prev) => ({
        ...prev,
        recipientProfile: resp,
        channel: resp.Email ? 'email' : 'sms',
      }))

      set(tableStateResult, (prev) => ({
        ...prev,
        items: bounces.Bounces.EventList,
        totalItems: bounces.Bounces.TotalItems,
        loading: false,
        status: 'ready',
      }))

      set(pageState, (prev) => ({
        ...prev,
        status: 'ready',
      }))
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, {
        status: 'error',
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
    }))
  }

export const loadBounceTableCallback =
  ({ set, snapshot, reset }) =>
  async ({ idRecipient, pageNumber, pageSize, orderBy, orderDescending }) => {
    set(tableStateResult, (prev) => ({
      ...prev,
      loading: true,
      status: 'initial',
    }))

    try {
      const search = await snapshot.getPromise(tableStateSerach)

      const searchParams = {
        ...search,
        pageNumber: pageNumber || search.pageNumber,
        pageSize: pageSize || search.pageSize,
        orderDescending:
          orderBy === search.orderBy
            ? !search.orderDescending
            : search.orderDescending,
        orderBy: orderBy || search.orderBy,
      }

      let resp = await getRecipientEventsBouncesAction(
        idRecipient,
        searchParams.pageSize,
        searchParams.pageNumber,
        searchParams.orderBy,
        searchParams.orderDescending,
      )

      if (
        resp.Bounces.EventList.length === 0 &&
        resp.Bounces.TotalItems > 0 &&
        searchParams.pageNumber > 0
      ) {
        searchParams.pageNumber = Math.ceil(
          resp.Bounces.TotalItems / searchParams.pageSize,
        )
        resp = await getRecipientEventsBouncesAction(
          idRecipient,
          searchParams.pageSize,
          searchParams.pageNumber,
          searchParams.orderBy,
          searchParams.orderDescending,
        )
      }

      set(tableStateResult, (prev) => ({
        ...prev,
        items: resp.Bounces.EventList,
        totalItems: resp.Bounces.TotalItems,
        loading: false,
        status: 'ready',
      }))

      set(tableStateSerach, searchParams)
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, {
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
        status: 'error',
      })
    }
  }

export const deleteBouncesCallback =
  ({ set, snapshot, reset }) =>
  async (idRecipient, listFakeId) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
    }))

    try {
      const request = {
        bounceList: [],
      }
      listFakeId.forEach((f) => {
        const arr = f.split('|')
        request.bounceList.push({
          BounceType: arr[0],
          IdMessage: Number.parseInt(arr[1]),
          IdSending: Number.parseInt(arr[2]),
          BounceDate: arr[3],
        })
      })
      await deleteRecipientEventsBouncesAction(idRecipient, request)
      reset(modalDeleteState)
      reset(selectedResultsState)

      toastShow(
        listFakeId.length > 1
          ? getIntl().formatMessage({
              id: 'Load.RecipientBounce.ModalDeleteConfirms',
            })
          : getIntl().formatMessage({
              id: 'Load.RecipientBounce.ModalDeleteConfirm',
            }),
        TOAST_VARIANT_SUCCESS,
        'ModalDeleteConfirm',
      )
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, {
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
        status: 'error',
      })
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
    }))
  }

export const resetPageCallback =
  ({ reset }) =>
  async () => {
    reset(pageState)
    reset(modalDeleteState)
    reset(recipientState)
    reset(tableStateSerach)
    reset(tableStateResult)
    reset(selectedResultsState)
  }
